var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { useMutation } from '@tanstack/react-query';
import { useBundle } from '@amzn/react-arb-tools';
import { Status } from '@amzn/handshake-painter-typescript-client/v1';
import { ReportActionSource } from '@amzn/handshake-painter-typescript-client/v1';
import { HandshakePainterServiceApiV1 } from 'src/api/handshakeApi';
import { useAlert } from 'src/common/alert/AlertContext';
import { useAnalyticsContext } from 'src/common/metrics';
import { useDefaultApiParams } from 'src/hooks';
import { RetailRoutes, useRetailRedirectUrls } from 'src/utils/links';
import { ExternalLink } from 'src/common/externalLink';
export const useAddToCart = () => {
    const { getDefaultParams } = useDefaultApiParams();
    const [bundle] = useBundle('pages.app');
    const { showAlert } = useAlert();
    const redirectUrls = useRetailRedirectUrls([RetailRoutes.VIEW_CART]);
    const rumClient = useAnalyticsContext();
    return useMutation({
        mutationFn: (_a) => __awaiter(void 0, [_a], void 0, function* ({ addToCartRequest, cartAddSource, isPrime }) {
            const defaultParams = getDefaultParams();
            return yield HandshakePainterServiceApiV1.addItemsToCart({
                addToCartRequest,
                xCartAddSource: cartAddSource,
                xIsPrime: isPrime,
                antiCsrftokenA2z: defaultParams.antiCsrftokenA2z,
                xUserLinked: defaultParams.xUserLinked,
                marketplaceId: defaultParams.marketplaceId,
            });
        }),
        onSuccess: (response) => {
            if (response.status === Status.Success) {
                showAlert({
                    type: 'success',
                    message: bundle.formatMessage('completeCheckoutWithLink', {
                        CartLink: (chunks) => (_jsx(ExternalLink, { id: "cart-link", underline: true, href: redirectUrls.VIEW_CART, source: ReportActionSource.CartAddMessage, children: chunks }, "cart-link")),
                    }),
                });
                return;
            }
            const hasIncompleteAdd = Object.values(response.cartItemResponses).some((item) => { var _a; return ((_a = item.cartItemErrorResponse) === null || _a === void 0 ? void 0 : _a.errorCode) === 'INCOMPLETE_ADD'; });
            showAlert({
                type: 'error',
                message: hasIncompleteAdd
                    ? bundle.getMessage('failedInsufficientQuantity')
                    : bundle.getMessage('failedTryAgain'),
            });
        },
        onError: (error) => {
            var _a;
            rumClient.recordEvent('ADD_TO_CART_API_ERROR', {
                errorTitle: error === null || error === void 0 ? void 0 : error.title,
                errorDetails: (_a = error === null || error === void 0 ? void 0 : error.detail) !== null && _a !== void 0 ? _a : String(error),
            });
            showAlert({
                type: 'error',
                message: bundle.getMessage('failedTryAgain'),
            });
        },
    });
};
